import {
  PARTNER_COMPANIES_CONTRACT_STATUS_COLOR,
  PARTNER_COMPANIES_CONTRACT_STATUS_NAME,
  PartnerCompaniesContractStatusEnum,
} from '@constants';

import type { PartnerCompanyStatusChipProps } from './types';
import { StyledChip } from './styles';

export function PartnerCompanyStatusChip({
  status,
  text,
  title,
  fontSize,
  size = 'medium',
  ...restPartnerCompanyStatusChipProps
}: Readonly<PartnerCompanyStatusChipProps>) {
  const statusMapping: Record<
    PartnerCompaniesContractStatusEnum,
    { label: string; color: string }
  > = {
    [PartnerCompaniesContractStatusEnum.ACTIVE]: {
      label:
        PARTNER_COMPANIES_CONTRACT_STATUS_NAME[
          PartnerCompaniesContractStatusEnum.ACTIVE
        ],
      color:
        PARTNER_COMPANIES_CONTRACT_STATUS_COLOR[
          PartnerCompaniesContractStatusEnum.ACTIVE
        ],
    },
    [PartnerCompaniesContractStatusEnum.CANCELED]: {
      label:
        PARTNER_COMPANIES_CONTRACT_STATUS_NAME[
          PartnerCompaniesContractStatusEnum.CANCELED
        ],
      color:
        PARTNER_COMPANIES_CONTRACT_STATUS_COLOR[
          PartnerCompaniesContractStatusEnum.CANCELED
        ],
    },
  };

  const { label, color } = statusMapping[status];

  return (
    <StyledChip
      chipColor={color}
      label={text ?? label}
      title={title}
      fontSize={fontSize}
      size={size}
      variant="outlined"
      {...restPartnerCompanyStatusChipProps}
    />
  );
}
